import React from 'react';
import { FormattedMessage } from 'react-intl';
import { EasyClaimDocumentType } from 'src/easyclaim.api.client.typescript/src';
import { OverallDashboardPlaceholder } from 'src/easyclaim.app.components/common/ImageRepository';
import { reportError } from 'src/easyclaim.app.libs/reportError';
import styled from 'styled-components';

import { AppState } from '../AppState';
import { PlaceholderVinV2 } from '../easyclaim.app.assets/index';
import {
	DetailContainer,
	DetailsContainer,
	SelectImage,
	StyledInfoIcon,
	ExampleModalImage,
} from '../easyclaim.app.components/index';
import { getConfiguration } from '../easyclaim.app.configuration/configuration';
import { ImageSelectionService } from '../easyclaim.app.services';

import { ScreenComponent } from './ScreenComponent';

interface OverallDashboardImageState {}

export class OverallDashboardImage extends ScreenComponent<AppState, OverallDashboardImageState> {
	constructor(props: AppState) {
		super(props);

		this.state = {};
		this.showOverallDashboardImageExampleModal =
			this.showOverallDashboardImageExampleModal.bind(this);
	}

	async showOverallDashboardImageExampleModal() {
		const customerName = this.props.easyClaimCase?._configuration?.companyShortName;
		const imageSrcFromConfiguration = getConfiguration(
			'exampleOverallDashboardImage',
			customerName
		);
		const baseUrl = `${process.env.PUBLIC_URL}/images/`;
		const imageSrcSufix = imageSrcFromConfiguration;
		const imageSrc = baseUrl + imageSrcSufix;
		const images: ExampleModalImage[] = [
			{
				src: imageSrc,
			},
		];

		await this.props.showExampleModal(
			images,
			'overallDashboardImageExampleModal.headline.first',
			null,
			'exampleOverallDashboardImage'
		);
	}

	public render() {
		return (
			<div className="main-container">
				<h2 className="overall-dashboard-title">
					<FormattedMessage id="overallDashboardImage.title" />
				</h2>
				<DetailsContainer>
					<DetailContainer>
						<Paragraph>
							<FormattedMessage id="overallDashboardImage.description" />{' '}
							<StyledInfoIcon
								onClick={() => {
									void this.showOverallDashboardImageExampleModal().catch((error: unknown) => {
										reportError(error, { context: 'OverallDashboardImage.asyncAction' });
									});
								}}
							/>
						</Paragraph>
						<SelectImage
							componentId="overallDashboardImage"
							fileType={EasyClaimDocumentType.OverallDashboardPicture}
							caseId={this.props.easyClaimCase?.caseId}
							easyClaimService={this.props.easyClaimService}
							currentImage={this.props.overallDashboardImage}
							title="overallDashboardImage.headline"
							marginBottom="1rem"
							onChange={(image) => {
								const isImageLoading = ImageSelectionService.isImageLoading(image);

								const newState = Object.assign({}, this.props, {
									overallDashboardImage: image,
									isImageLoading: isImageLoading,
								});

								void this.props.setAppState(newState);
							}}
							onShowExample={() => {
								void this.showOverallDashboardImageExampleModal().catch((error: unknown) => {
									reportError(error, {
										context: 'OverallDashboardImage.showOverallDashboardImageExampleModal',
									});
								});
							}}
							showUserFeedbackInfo={true}
							placeholder={<OverallDashboardPlaceholder />}
							configuration={this.props.easyClaimCase!._configuration!}
							inputError={this.props.inputError}
							canOverlayCamera={this.props.easyClaimCase?._configuration?.canShowOverlayOnCamera}
						/>
					</DetailContainer>
				</DetailsContainer>
			</div>
		);
	}
}

const StyledPlaceholderVin = styled(PlaceholderVinV2)`
	fill: ${(p) => p.theme.colors.primary};
	color: ${(p) => p.theme.colors.primary};
	background-color: white;
	width: auto;
	display: block;
	border-radius: 3px;
	opacity: 0.95;
`;

const Paragraph = styled.p`
	margin-bottom: 1rem;
	hyphens: auto;
	user-select: none;
	cursor: default;
`;
